import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Suspense as _Suspense, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lg:pb-12 w-full" }
const _hoisted_2 = { class: "default" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "hidden lg:block ml-12 menu"
}
const _hoisted_6 = { class: "hidden lg:block menu" }
const _hoisted_7 = {
  key: 1,
  class: "lg:hidden menu"
}

import { ref, watch } from "vue";
import { Bars3Icon, LockClosedIcon, MoonIcon, PowerIcon, SunIcon } from '@heroicons/vue/24/outline';
import { useRoute } from "vue-router";
import { TransitionRoot } from '@headlessui/vue'

import { pb } from "@/pocketbase";
import router from "@/router";
import LoadingView from "@/views/LoadingView.vue";
import tsgLogo from "@/assets/img/tsg-group-circle.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const route = useRoute();
const isLoggedIn = ref(pb.authStore.isValid && pb.authStore.model.verified);
const showMobileMenu = ref(false);

pb.authStore.onChange((token, model) => {
  isLoggedIn.value = !!token && model?.verified;
});

watch(
    () => route.fullPath,
    async () => {
      showMobileMenu.value = false;
    }
);

function logout() {
  pb.authStore.clear();
  router.push('/login');
}

function toggleTheme() {
  if (localStorage.theme === 'dark') {
    document.documentElement.classList.remove('dark')
    localStorage.theme = 'light';
  } else {
    document.documentElement.classList.add('dark')
    localStorage.theme = 'dark';
  }
  showMobileMenu.value = false;

  window.dispatchEvent(new CustomEvent('theme-changed', {
    detail: {
      theme: localStorage.theme,
    }
  }));
}

function toggleMenu() {
  showMobileMenu.value = !showMobileMenu.value;
}

function goToAdmin() {
  window.open(process.env.VUE_APP_POCKETBASE_URL + '/_/', '_blank');
}

const atTopOfPage = ref(true);
window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    if (atTopOfPage.value) {
      atTopOfPage.value = false
    }
  } else if (!atTopOfPage.value) {
    atTopOfPage.value = true
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['sticky top-0 p-4 lg:p-0 z-10', atTopOfPage.value ? '' : 'shadow-lg'])
    }, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'home' },
            tag: "div",
            class: "flex items-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(tsgLogo),
                class: "max-w-[2rem] mr-2",
                alt: "TSG Logo"
              }, null, 8, _hoisted_4),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-sm font-bold tracking-tight text-gray-900 dark:text-white" }, [
                _createElementVNode("div", { class: "font-bold" }, "TSG R&D"),
                _createElementVNode("div", { class: "font-light" }, "Collaboration Hub")
              ], -1))
            ]),
            _: 1,
            __: [0]
          }),
          (isLoggedIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_router_link, { to: { name: 'home' } }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Home")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createVNode(_component_router_link, { to: { name: 'business_units' } }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Business Units")
                  ])),
                  _: 1,
                  __: [2]
                }),
                _createVNode(_component_router_link, { to: { name: 'tech_landscape' } }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Tech Landscape")
                  ])),
                  _: 1,
                  __: [3]
                }),
                _createVNode(_component_router_link, { to: { name: 'events' } }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Events")
                  ])),
                  _: 1,
                  __: [4]
                }),
                _createVNode(_component_router_link, { to: { name: 'resources' } }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Resources")
                  ])),
                  _: 1,
                  __: [5]
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(MoonIcon), {
              class: "icon w-4 h-4 hidden dark:inline-block",
              onClick: toggleTheme
            }),
            _createVNode(_unref(SunIcon), {
              class: "icon w-4 h-4 inline-block dark:hidden",
              onClick: toggleTheme
            }),
            (isLoggedIn.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(LockClosedIcon), {
                    class: "icon w-4 h-4 inline-block",
                    onClick: goToAdmin
                  }),
                  _createVNode(_unref(PowerIcon), {
                    class: "icon w-4 h-4 inline-block",
                    onClick: logout
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (isLoggedIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(Bars3Icon), {
                  class: "icon w-8 h-8",
                  onClick: toggleMenu
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_unref(TransitionRoot), {
        show: isLoggedIn.value && showMobileMenu.value,
        as: "nav",
        class: "mobile",
        enter: "transform origin-top-left ease-in-out duration-500",
        "enter-from": "scale-y-0",
        "enter-to": "scale-y-100",
        leave: "transform origin-top-left ease-in-out duration-500",
        "leave-from": "scale-y-100",
        "leave-to": "scale-y-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: { name: 'home' } }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Home")
            ])),
            _: 1,
            __: [6]
          }),
          _createVNode(_component_router_link, { to: { name: 'business_units' } }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Business Units")
            ])),
            _: 1,
            __: [7]
          }),
          _createVNode(_component_router_link, { to: { name: 'tech_landscape' } }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Tech Landscape")
            ])),
            _: 1,
            __: [8]
          }),
          _createVNode(_component_router_link, { to: { name: 'events' } }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Events")
            ])),
            _: 1,
            __: [9]
          }),
          _createVNode(_component_router_link, { to: { name: 'resources' } }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Resources")
            ])),
            _: 1,
            __: [10]
          }),
          _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("a", {
            href: "#",
            class: "opacity-70",
            onClick: _withModifiers(toggleTheme, ["prevent"])
          }, "Toggle Theme"),
          _createElementVNode("a", {
            href: "#",
            class: "opacity-70",
            onClick: _withModifiers(logout, ["prevent"])
          }, "Sign Out")
        ]),
        _: 1,
        __: [11]
      }, 8, ["show"])
    ], 2),
    (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      fallback: _withCtx(() => [
        _createVNode(LoadingView)
      ]),
      _: 3
    }))
  ]))
}
}

})